/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Title from "../../ui/Title";
import { useBooking } from "../../../hooks/useBooking";
import SummaryItemsTable from "./SummaryTable";
import SummaryTotals from "./SummaryTotals";
import useInvoice from "../../../hooks/checkout/useInvoice";
import { useActiveFlow } from "../../../hooks/useActiveFlow";
import { FlowType } from "../../../store/slices/flowSlice";
import { invoiceLinesToItems } from "../../../utils/invoiceItems";
import Stack from "../../ui/Stack";

const SummarySection = styled(Stack)`
  display: grid;
  padding: 1rem;
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
  border-radius: 1rem;
  box-shadow: 2px 2px 15px rgba(${({ theme }) => theme.colors.text.rgb}, 0.1);

  ${({ theme }) => theme.containerMedia.sm} {
    padding: 0;
    box-shadow: none;
    border: none;
  }
`;

const CheckoutSummary = ({ children, renderLineExtra }) => {
  const { selectedServices } = useBooking();
  const { invoice } = useInvoice();
  const activeFlow = useActiveFlow();

  const itemsForRender =
    activeFlow === FlowType.BOOKING ? selectedServices : invoiceLinesToItems(invoice);

  return (
    <SummarySection $gap="1rem">
      <Title size="h3">Summary</Title>
      <Stack $gap="2rem">
        <Stack $gap="1rem">
          <SummaryItemsTable items={itemsForRender} invoice={invoice} renderLineExtra={renderLineExtra} />
          <SummaryTotals invoice={invoice} />
        </Stack>
        {children}
      </Stack>
    </SummarySection>
  );
};

export default CheckoutSummary;
